// External Imports
import { createSelector } from 'reselect';

// Internal Imports
import { redirects } from '../config/redirects.mjs';
import { selectMatch } from './selectMatch.mjs';

// Local Functions
const normalizePath = (path) => {
  let normalizedPath = path;
  if (!path.startsWith('/')) {
    normalizedPath = `/${normalizedPath}`;
  }
  if (path.endsWith('/')) {
    normalizedPath = normalizedPath.slice(0, -1);
  }
  return normalizedPath;
};

/**
 * Find the first redirect pattern that matches the current url path,
 * and return the new url to redirect to.
 * @return {string}
 */
const selectRedirect = createSelector(
  [(state) => state.redirect, selectMatch],
  // eslint-disable-next-line consistent-return -- Optional return
  (redirectMap, { url }) => {
    const matchingRegexpRedirect = redirects.find(({ pattern }) => url.match(pattern));
    if (matchingRegexpRedirect) {
      const { pattern, replace } = matchingRegexpRedirect;
      const replacedUrl = url.replace(pattern, replace);
      return replacedUrl === '' ? undefined : replacedUrl;
    }
    const matchingWordPressRedirect = Object.entries(redirectMap).find(
      ([from]) => normalizePath(from) === normalizePath(url),
    );
    if (matchingWordPressRedirect) {
      const [from, to] = matchingWordPressRedirect;
      if (URL.canParse(to)) {
        return to;
      }
      return url.replace(url, normalizePath(url)).replace(normalizePath(from), normalizePath(to));
    }
  },
);

// Module Exports
export { selectRedirect };
